const logLevels = {
    DEBUG: 'debug',
    INFO: 'info',
    WARN: 'warn',
    ERROR: 'error'
  };
  
  const shouldLog = process.env.NODE_ENV === 'development';
  
  const logger = {
    debug: (message, data = {}) => {
      if (shouldLog) {
        console.log(`%c[DEBUG] ${message}`, 'color: #4CAF50; font-weight: bold', data);
      }
    },
    
    info: (message, data = {}) => {
      if (shouldLog) {
        console.log(`%c[INFO] ${message}`, 'color: #2196F3; font-weight: bold', data);
      }
    },
    
    warn: (message, data = {}) => {
      if (shouldLog) {
        console.warn(`%c[WARN] ${message}`, 'color: #FF9800; font-weight: bold', data);
      }
    },
    
    error: (message, data = {}) => {
      console.error(`%c[ERROR] ${message}`, 'color: #F44336; font-weight: bold', data);
    }
  };
  
  export default logger;